// Los tres helpers son no-op cuando Clarity no está cargado, que es SIEMPRE fuera de
// producción: `index.js` solo llama a initClarity con NODE_ENV === 'production'. O sea
// que lo que se instrumente acá no deja rastro en local ni en staging, y no hay número
// que mirar hasta que el código llegue a prod.
//
// El shim de arriba encola las llamadas en `clarity.q` hasta que baja el script, así
// que no hace falta esperar a nada para taguear.

// Dimensión para segmentar sesiones. Se puede filtrar por ella en el dashboard y saltar
// directo a las grabaciones de ese segmento.
export function clarityTag(key, value) {
  try {
    if (typeof window === 'undefined' || !window.clarity) return
    window.clarity('set', key, String(value))
  } catch (e) {
    // no-op
  }
}

// Acción puntual del usuario. Aparece como Smart event y sirve de filtro.
export function clarityEvent(name) {
  try {
    if (typeof window === 'undefined' || !window.clarity) return
    window.clarity('event', name)
  } catch (e) {
    // no-op
  }
}

// Sin esto Clarity cuenta SESIONES, no personas: el mismo usuario entrando tres días
// seguidos son tres. Con el id se pueden contar usuarios únicos, que es la pregunta
// real cuando se mide adopción.
export function clarityIdentify(userId) {
  try {
    if (typeof window === 'undefined' || !window.clarity || !userId) return
    window.clarity('identify', String(userId))
  } catch (e) {
    // no-op
  }
}

export function initClarity(projectId) {
  try {
    if (typeof window === 'undefined') return
    if (!projectId) return
    if (window.clarity) return

    ;(function (c, l, a, r, i, t, y) {
      c[a] = c[a] || function () {
        ;(c[a].q = c[a].q || []).push(arguments)
      }
      t = l.createElement(r)
      t.async = 1
      t.src = 'https://www.clarity.ms/tag/' + i
      y = l.getElementsByTagName(r)[0]
      y.parentNode.insertBefore(t, y)
    })(window, document, 'clarity', 'script', projectId)
  } catch (e) {
    // no-op
  }
}

